export const VALID_CHARS_REGEX_FOR_MIXED_LETTER = /^[אבגדהוזחטיכלמנסעפצקרשתabcdefghijklmnopqrstuvwxyz0123456789]*$/i